"use client";

import styles from "./SiteLogoLoader.module.css";
import defaultLogo from "src/assets/images/logo-horizontal.png";

interface SiteLogoLoaderProps {
  label?: string;
  logoSrc?: string;
  overlay?: boolean;
}

export function SiteLogoLoader({
  label = "",
  logoSrc = defaultLogo,
  overlay = false,
}: SiteLogoLoaderProps) {
  return (
    <div className={`${styles.loader} ${overlay ? styles.overlayLoader : ""}`} role="status" aria-live="polite">
      <div className={styles.logoMotion}>
        <span className={styles.orbit} aria-hidden="true" />
        <img className={styles.logo} src={logoSrc} alt="AIGENDRUG" />
      </div>
      <p className={styles.label}>{label}</p>
    </div>
  );
}
